import { BillingAddress, Checkout, PersonalDetailsInputType } from "@/common/lib/types";
import { useMemo } from "react";

export const getCncPersonalDetails = (billingAddress: BillingAddress | undefined): PersonalDetailsInputType => {
  try {
    const details = billingAddress?.metadata?.find((item) => item.key === "personalDetails")?.value as string;

    if (!details) {
      return {} as PersonalDetailsInputType;
    }

    const parsedDetails = JSON.parse(details) as PersonalDetailsInputType;

    // Optional: Validate the parsed object
    if (typeof parsedDetails !== "object" || parsedDetails === null) {
      return {} as PersonalDetailsInputType;
    }

    return parsedDetails;
  } catch (error) {
    return {} as PersonalDetailsInputType;
  }
};

const useCncPersonalDetails = (checkout: Checkout | undefined): PersonalDetailsInputType => {
  return useMemo(() => {
    return getCncPersonalDetails(checkout?.billingAddress);
  }, [checkout?.billingAddress]);
};

export default useCncPersonalDetails;
